import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { callMsGraph } from '../utils/MsGraphApiCall';

const API_URL = 'https://nice-sky-008b0db0f.5.azurestaticapps.net/api/';
const API_KEY = '6ws67Oj0csDneKWLmQYeCwkQVy_yBg_8tN1AmcTmZM6xAzFuJwmBSw==';

// Fetch user data
const useUser = () => {
  const [userMail, setUserMail] = useState(null);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const userData = await callMsGraph();
        setUserMail(userData.mail);
        console.log('Fetched userMail:', userData.mail); // Log userMail here
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };

    fetchUserData();
  }, []);

  return userMail;
};

// List jobs
export const listJobs = async (userMail) => {
  try {
    const headers = {
      'x-ms-sdg-unep-id': userMail
    };
    const response = await axios.get(`${API_URL}list_jobs/`, {
      headers,
      params: { code: API_KEY },
    });
    return response.data;
  } catch (error) {
    console.error('Error listing jobs:', error);
    throw error;
  }
};

export const createJob = async (userMail) => {
  try {
    const headers = {
      'x-ms-sdg-unep-id': userMail
    };
    const response = await axios.post(`${API_URL}create_job`, null, {
      headers,
      params: { code: API_KEY },
    });
    return response.data;
  } catch (error) {
    console.error('Error creating job:', error);
  }
};

export const uploadFiles = async (file, userMail) => {
  try {
    const headers = {
      'Content-Type': 'multipart/form-data',
      'x-ms-sdg-unep-id': userMail
    };
    const formData = new FormData();
    formData.append('file', file);

    const response = await axios.post(`${API_URL}upload_files`, formData, {
      headers,
      params: { code: API_KEY },
    });
    return response.data;
  } catch (error) {
    console.error('Error uploading file:', error);
  }
};

export const downloadFiles = async (jobId, userMail) => {
  try {
    const headers = {
      'x-ms-sdg-unep-id': userMail
    };
    const response = await axios.get(`${API_URL}download_files`, {
      headers,
      params: { code: API_KEY, job_id: jobId },
      responseType: 'blob',
    });
    return response.data;
  } catch (error) {
    console.error('Error downloading file:', error);
  }
};

// Component using useUser
const JobHandler = () => {
  const userMail = useUser();

  const handleListJobs = async () => {
    try {
      if (!userMail) throw new Error('User mail not available');
      const jobs = await listJobs(userMail);
      console.log('Jobs:', jobs);
    } catch (error) {
      console.error('Error fetching jobs:', error);
    }
  };

  return (
    <div>
      <button onClick={handleListJobs} disabled={!userMail}>
        List Jobs
      </button>
    </div>
  );
};

export default JobHandler;
